import React from 'react';
import { FileUploadProps } from './FileUploadProps';
import FileInfoCard from './FileInfoCard';
import If from '../If/If';
import AddFileButton from './AddFileButton';
import styled from 'styled-components';

const ListStyles = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
`;

export interface FileListProps extends FileUploadProps {
  onFileAdd?: () => void;
}

const FileList: React.FC<FileListProps> = ({
  files = [],
  disableDelete,
  disableUpload,
  onFileDelete,
  onFileOpen,
  onFileAdd,
  deleteTxt,
}) => {
  return (
    <ListStyles>
      {files.map((file) => (
        <FileInfoCard
          key={file.id ?? file.name}
          onOpen={onFileOpen ? () => onFileOpen(file) : undefined}
          onDelete={disableDelete || !onFileDelete ? undefined : () => onFileDelete(file)}
          deleteTxt={deleteTxt}
          {...file}
        />
      ))}
      <If condition={!disableUpload && !!onFileAdd}>
        <AddFileButton onClick={onFileAdd} />
      </If>
    </ListStyles>
  );
};

export default React.memo(FileList);
